/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingnoconnectedaccounts3Inputs */

const en_crosspostingnoconnectedaccounts3 = /** @type {(inputs: Crosspostingnoconnectedaccounts3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect at least one account for this place before cross-posting.`)
};

const de_crosspostingnoconnectedaccounts3 = /** @type {(inputs: Crosspostingnoconnectedaccounts3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbinde mindestens ein Konto für diesen Ort, bevor du überall veröffentlichst.`)
};

/**
* | output |
* | --- |
* | "Connect at least one account for this place before cross-posting." |
*
* @param {Crosspostingnoconnectedaccounts3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingnoconnectedaccounts3 = /** @type {((inputs?: Crosspostingnoconnectedaccounts3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingnoconnectedaccounts3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingnoconnectedaccounts3(inputs)
	return de_crosspostingnoconnectedaccounts3(inputs)
});
export { crosspostingnoconnectedaccounts3 as "crosspostingNoConnectedAccounts" }